/*
 * @Descripttion: 场景价格管理常量
 * @Date: 2026-07-02 10:00:00
 */

/** 价格下限（元） */
export const MIN_PRICE = 0;

/** 价格上限（元） */
export const MAX_PRICE = 1000;

/** 价格小数位数 */
export const PRICE_DECIMALS = 2;
